import * as React from "react";
import { SVGProps } from "react";
const SvgDivider = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 1 32" {...props}>
    <path stroke="#8F9192" d="M1 0v32" />
  </svg>
);
export default SvgDivider;
